import { css, styled, textEllipsis } from 'canoe';

import DropInContainer from 'craft/components/DropInContainer';

export const DropInBox = styled(DropInContainer)`
  ${({ theme, disabled }) => css`
    width: 97px;
    height: 107px;
    display: flex;
    flex-direction: column;
    justify-content: space-between;
    padding: ${theme.spaces.xs};
    background-color: ${theme.colors.White};
    border: 1px solid ${theme.colors.GlitterGray};
    border-radius: ${theme.borderRadius.small};
    cursor: grab;

    &:active {
      cursor: grabbing;
    }

    ${disabled &&
    css`
      cursor: not-allowed;

      &:active {
        cursor: not-allowed;
      }
    `}
  `}
`;

export const DropInLabel = styled.span`
  ${({ theme }) => css`
    display: block;
    max-width: 100%;
    max-height: 30px;
    font-size: 11px;
    line-height: 11px;
    color: ${theme.colors.OnyxGrayD10};
    text-align: center;
  `}
`;

export const DropInThumbnail = styled.div<{ alignContent?: string }>`
  ${({ alignContent = 'center' }) => css`
    width: 81px;
    max-height: 66px;
    flex-shrink: 0;
    flex-grow: 1;
    display: flex;
    align-items: center;
    justify-content: center;
    line-height: 100% !important;
    ${textEllipsis};

    ${alignContent === 'end' &&
    css`
      align-items: flex-end;
    `}

    ${alignContent === 'start' &&
    css`
      align-items: flex-start;
    `}
  `}
`;
